import React, { useState } from 'react';
import { Star, Shield, ChevronDown, BookOpen, Headphones, FileText, List, Quote, Users } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function BundleOffer() {
  const [expanded, setExpanded] = useState<number | null>(null);
  const toggleExpand = (index: number) => {
    setExpanded(expanded === index ? null : index);
  };
  return <section id="offer" className="bg-white py-12 px-4" data-id="element-49">
      <div className="max-w-3xl mx-auto bg-gray-50 rounded-2xl border-2 border-blue-100 shadow-xl overflow-hidden relative" data-id="element-50">
        <div className="bg-navy text-white py-3 px-4 flex items-center justify-center gap-3" data-id="element-51">
          <Star className="text-gold" size={20} fill="currentColor" data-id="element-52" />
          <h2 className="text-xl md:text-2xl font-bold m-0" data-id="element-53">
            Special American Values Offer
          </h2>
          <Star className="text-gold" size={20} fill="currentColor" data-id="element-54" />
        </div>

        <div className="absolute top-16 right-0 bg-patriot-red text-white text-xs font-bold px-8 py-1 transform rotate-45 translate-x-6 translate-y-4 shadow-md z-10" data-id="element-55">
          DIGITAL BUNDLE
        </div>

        <div className="p-6 md:p-8 text-center" data-id="element-56">
          <div className="bg-red-100 text-patriot-red-dark font-bold py-2 px-4 rounded-md inline-block mb-6 border border-red-200" data-id="element-57">
            URGENT: Only <span className="text-xl" data-id="element-58">123</span> copies left at
            this price!
          </div>

          <h3 className="text-2xl md:text-3xl font-bold text-navy mb-2" data-id="element-59">
            Unlock The Charlie Kirk Collector Bundle
          </h3>
          <p className="text-lg text-gray-600 mb-1" data-id="element-60">
            Narrated Biography + Collector's Tribute + Legacy Action Guide
          </p>
          <p className="text-xl text-patriot-red font-bold mb-8" data-id="element-61">
            <span className="line-through text-gray-400 mr-2" data-id="element-62">
              $95.94 Value
            </span>{' '}
            Today just <span className="text-2xl" data-id="element-63">$17</span>
          </p>

          <div className="relative mb-8 max-w-lg mx-auto" data-id="element-64">
            <img src="https://cdn.magicpatterns.com/uploads/8VhdCTKEB5SoAzmACwizSF/Mockup_Audio_Book_Charlie_Kirk.png" alt="The Charlie Kirk Collector Bundle" className="w-full h-auto drop-shadow-2xl" data-id="element-65" />
          </div>

          <div className="text-gray-700 space-y-3 text-left max-w-lg mx-auto" data-id="element-66">
            {/* Product 1 */}
            <div className="bg-white rounded-lg border border-gray-200 overflow-hidden" data-id="element-67">
              <div className="p-4" data-id="element-68">
                <p className="font-bold text-navy" data-id="element-69">
                  The Main Archive: Voices of Freedom{' '}
                  <span className="text-gold font-bold" data-id="element-70">— $47.97 Value</span>
                </p>
                <p className="text-gray-500 text-sm mt-1 italic" data-id="element-71">
                  "The definitive account of the journey from a suburban
                  basement to the front lines of the culture war."
                </p>
                <button onClick={() => toggleExpand(0)} className="flex items-center gap-1 text-navy text-sm font-semibold mt-2 hover:text-patriot-red transition-colors" data-id="element-72">
                  {expanded === 0 ? 'Show less' : "Read more — what's included"}
                  <ChevronDown size={16} className={`transition-transform duration-300 ${expanded === 0 ? 'rotate-180' : ''}`} data-id="element-73" />
                </button>
              </div>
              <div className={`overflow-hidden transition-all duration-300 ease-in-out ${expanded === 0 ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-74">
                <div className="px-4 pb-4 pt-1 border-t border-gray-100" data-id="element-75">
                  <p className="text-xs text-gray-500 uppercase font-bold mb-2 tracking-wide" data-id="element-76">
                    What's inside:
                  </p>
                  <ul className="space-y-2" data-id="element-77">
                    <li className="flex items-start gap-2 text-sm text-gray-600" data-id="element-78">
                      <BookOpen size={14} className="text-navy flex-shrink-0 mt-0.5" data-id="element-79" />
                      <span data-id="element-80">Full-length eBook (PDF) — read on any device</span>
                    </li>
                    <li className="flex items-start gap-2 text-sm text-gray-600" data-id="element-81">
                      <Headphones size={14} className="text-navy flex-shrink-0 mt-0.5" data-id="element-82" />
                      <span data-id="element-83">
                        Narrated audiobook (MP3, 75 min) — listen on the go
                      </span>
                    </li>
                    <li className="flex items-start gap-2 text-sm text-gray-600" data-id="element-84">
                      <FileText size={14} className="text-navy flex-shrink-0 mt-0.5" data-id="element-85" />
                      <span data-id="element-86">
                        Charlie's early years, defining decisions, and rise to
                        national influence
                      </span>
                    </li>
                    <li className="flex items-start gap-2 text-sm text-gray-600" data-id="element-87">
                      <Quote size={14} className="text-navy flex-shrink-0 mt-0.5" data-id="element-88" />
                      <span data-id="element-89">
                        Key speeches, debates, and the moments that shaped the
                        movement
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Product 2 */}
            <div className="bg-white rounded-lg border border-gray-200 overflow-hidden" data-id="element-90">
              <div className="p-4" data-id="element-91">
                <p className="font-bold text-navy" data-id="element-92">
                  The Heritage Timeline: Remembering Charlie Kirk{' '}
                  <span className="text-gold font-bold" data-id="element-93">— $23.98 Value</span>
                </p>
                <p className="text-gray-500 text-sm mt-1 italic" data-id="element-94">
                  "A year-by-year timeline of the movement's most defining
                  moments and the quotes that sparked a generation."
                </p>
                <button onClick={() => toggleExpand(1)} className="flex items-center gap-1 text-navy text-sm font-semibold mt-2 hover:text-patriot-red transition-colors" data-id="element-95">
                  {expanded === 1 ? 'Show less' : "Read more — what's included"}
                  <ChevronDown size={16} className={`transition-transform duration-300 ${expanded === 1 ? 'rotate-180' : ''}`} data-id="element-96" />
                </button>
              </div>
              <div className={`overflow-hidden transition-all duration-300 ease-in-out ${expanded === 1 ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-97">
                <div className="px-4 pb-4 pt-1 border-t border-gray-100" data-id="element-98">
                  <p className="text-xs text-gray-500 uppercase font-bold mb-2 tracking-wide" data-id="element-99">
                    What's inside:
                  </p>
                  <ul className="space-y-2" data-id="element-100">
                    <li className="flex items-start gap-2 text-sm text-gray-600" data-id="element-101">
                      <BookOpen size={14} className="text-navy flex-shrink-0 mt-0.5" data-id="element-102" />
                      <span data-id="element-103">
                        Collector's tribute eBook (PDF) — beautifully organized
                      </span>
                    </li>
                    <li className="flex items-start gap-2 text-sm text-gray-600" data-id="element-104">
                      <Headphones size={14} className="text-navy flex-shrink-0 mt-0.5" data-id="element-105" />
                      <span data-id="element-106">
                        Companion audiobook (MP3) — narrated tribute edition
                      </span>
                    </li>
                    <li className="flex items-start gap-2 text-sm text-gray-600" data-id="element-107">
                      <List size={14} className="text-navy flex-shrink-0 mt-0.5" data-id="element-108" />
                      <span data-id="element-109">
                        Year-by-year timeline of milestones, controversies, and
                        breakthroughs
                      </span>
                    </li>
                    <li className="flex items-start gap-2 text-sm text-gray-600" data-id="element-110">
                      <Quote size={14} className="text-navy flex-shrink-0 mt-0.5" data-id="element-111" />
                      <span data-id="element-112">
                        Curated collection of Charlie's most powerful and
                        shareable quotes
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Product 3 */}
            <div className="bg-white rounded-lg border border-gray-200 overflow-hidden" data-id="element-113">
              <div className="p-4" data-id="element-114">
                <p className="font-bold text-navy" data-id="element-115">
                  The Patriot's Playbook: The Last Patriot{' '}
                  <span className="text-gold font-bold" data-id="element-116">— $23.99 Value</span>
                </p>
                <p className="text-gray-500 text-sm mt-1 italic" data-id="element-117">
                  "Charlie's personal principles for survival and impact in a
                  cancel-culture world—turned into a practical roadmap for your
                  family."
                </p>
                <button onClick={() => toggleExpand(2)} className="flex items-center gap-1 text-navy text-sm font-semibold mt-2 hover:text-patriot-red transition-colors" data-id="element-118">
                  {expanded === 2 ? 'Show less' : "Read more — what's included"}
                  <ChevronDown size={16} className={`transition-transform duration-300 ${expanded === 2 ? 'rotate-180' : ''}`} data-id="element-119" />
                </button>
              </div>
              <div className={`overflow-hidden transition-all duration-300 ease-in-out ${expanded === 2 ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-120">
                <div className="px-4 pb-4 pt-1 border-t border-gray-100" data-id="element-121">
                  <p className="text-xs text-gray-500 uppercase font-bold mb-2 tracking-wide" data-id="element-122">
                    What's inside:
                  </p>
                  <ul className="space-y-2" data-id="element-123">
                    <li className="flex items-start gap-2 text-sm text-gray-600" data-id="element-124">
                      <BookOpen size={14} className="text-navy flex-shrink-0 mt-0.5" data-id="element-125" />
                      <span data-id="element-126">
                        Action guide eBook (PDF) — practical, step-by-step
                        format
                      </span>
                    </li>
                    <li className="flex items-start gap-2 text-sm text-gray-600" data-id="element-127">
                      <Headphones size={14} className="text-navy flex-shrink-0 mt-0.5" data-id="element-128" />
                      <span data-id="element-129">Companion audiobook (MP3) — listen and apply</span>
                    </li>
                    <li className="flex items-start gap-2 text-sm text-gray-600" data-id="element-130">
                      <Users size={14} className="text-navy flex-shrink-0 mt-0.5" data-id="element-131" />
                      <span data-id="element-132">
                        "Say-it-like-this" talking points for real conversations
                        with family and coworkers
                      </span>
                    </li>
                    <li className="flex items-start gap-2 text-sm text-gray-600" data-id="element-133">
                      <FileText size={14} className="text-navy flex-shrink-0 mt-0.5" data-id="element-134" />
                      <span data-id="element-135">
                        Strategies to stand firm in cancel-culture without
                        losing relationships
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-6 pt-6 border-t border-gray-200" data-id="element-136">
            <p className="text-gray-500 line-through text-lg" data-id="element-137">
              Total Value: $95.94
            </p>
            <p className="text-3xl font-bold text-navy mt-1" data-id="element-138">
              Yours Today: <span className="text-patriot-red" data-id="element-139">$17</span>
            </p>
            <p className="text-green-600 font-bold text-sm mt-1" data-id="element-140">
              You save $78.94 — 82% OFF
            </p>

            <div className="max-w-md mx-auto mt-6" data-id="element-141">
              <CTAButton data-id="element-142">YES — UNLOCK MY BUNDLE FOR $17 →</CTAButton>
              <div className="flex items-center justify-center gap-2 mt-3 text-gray-400 text-xs" data-id="element-143">
                <Shield size={12} data-id="element-144" />
                <span data-id="element-145">
                  Secure Checkout · Instant Digital Delivery · 100% Guaranteed
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}